<template>
  <path pid="0" d="M22.07 2.6l-19 9a1 1 0 00.19 1.87l7.41 1.86 1.86 7.41a1 1 0 001.87.19l9-19a1 1 0 00-1.33-1.33zm-8.28 17l-1.32-5.29a1 1 0 00-.73-.73l-5.29-1.37 14-6.61z"/>
</template>
